<template>
  <el-form ref="postForm" :rules="rules" :model="postForm">
    <el-form-item label="名称" prop="title">
      <el-input v-model="postForm.title" placeholder="请输入课程名称" style="width:80%" />
    </el-form-item>
    <el-form-item label="业务类型" prop="course_key">
      <Select key="100" :selected.sync="postForm.type" :data="bussinessType" clearable placeholder="请选择" />
    </el-form-item>
    <el-form-item v-if="postForm.type == 1" label="课时类型" prop="course_key">
      <Select key="4" :selected.sync="postForm.course_key" :data="courseKeys" clearable placeholder="请选择" />
    </el-form-item>
    <el-form-item v-if="postForm.type == 3" label="科目" prop="subject_id">
      <Select key="10044" :selected.sync="postForm.subject_id" url="Publiclib/getSmallClassSubject" clearable placeholder="请选择" />
    </el-form-item>
    <el-form-item label="优豆" prop="point_value">
      <el-input-number v-model="postForm.point_value" :min="1" :max="10000" label="描述文字" />
    </el-form-item>
    <!-- <el-form-item label="校区">
      <el-checkbox-group v-model="shopSelectors">
        <el-checkbox v-model="checkAllShops" @change="handleCheckAllShopChange">全选</el-checkbox>
        <el-checkbox v-for="(item,index) in shopLists" :key="'shop' + index" :label="item.id">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item> -->
    <el-form-item label="使用年级">
      <el-checkbox-group v-model="gradeSelectors">
        <el-checkbox v-model="checkAllGrade" @change="handleCheckAllGradeChange">全选</el-checkbox>
        <el-checkbox v-for="(item,index) in gradeLists" :key="'grade' + index" :label="item.id">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        class="fn-right"
        @click="fnHandleSave"
      >保存
      </el-button>
    </el-form-item>

  </el-form>
</template>
<script>

import Select from '@/components/Select'
// import UploadImg from '@/components/toolbar/UploadImg.vue'
import commondata from '@/utils/commondata'

const defaultForm = {
  point_value: '',
  course_key: '',
  type: '',
  title: '',
  subject_id: ''

}
import { validateRequire } from '@/utils/validate'

export default {
  name: 'AddFood',
  components: {
    Select
    // UploadImg
  },
  props: {
    food: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      selectList: [],
      shopLists: [],
      checkAllShops: false,
      checkAllGrade: false,

      shopSelectors: [],
      gradeSelectors: [],
      bussinessType: commondata.BUSSINESS_TYPE,
      courseKeys: commondata.COURSE_KEY,
      gradeLists: commondata.GRADE_LISTS,

      rules: {
        type: [{ validator: validateRequire, trigger: 'manual', message: '业务类型' }],
        // course_key: [{ validator: validateRequire, trigger: 'manual', message: '类型' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '科目' }],
        title: [{ validator: validateRequire, trigger: 'manual', message: '名称' }],
        point_value: [{ validator: validateRequire, trigger: 'manual', message: '优豆' }],
        food_material: [{ validator: validateRequire, trigger: 'manual', message: '配料' }]
      }
    }
  },
  created() {
    if (this.food) {
      this.postForm = Object.assign(this.postForm, this.food)
    }
  },
  mounted() {
    this.fnGetSelectList()
  },
  methods: {
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopLists = res.data
      })
    },
    fnHandleSave: function() {
    //  if (this.shopSelectors.length == 0 || this.gradeSelectors.length == 0) {
    //     return
    //   }
      if (this.postForm.type == 1 && !this.postForm.course_key) {
        this.$message({
          type: 'warning',
          message: '请填写类型'
        })
        return
      }
      const addForm = Object.assign({}, this.postForm)
      // addForm.shop_id = this.shopSelectors.join(',')
      addForm.grade_id = this.gradeSelectors.join(',')

      this.$refs.postForm.validate(valid => {
        console.log('aaaaaa')
        if (valid) {
          if (addForm.type == 3) {
            addForm.course_key = '201'
          }
          this.$http.createCreditsExchangeItem(addForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
            this.$emit('successCBK')
          })
        }
      })
    },
    handleCheckAllShopChange: function() {
      this.checkAllShops = !this.checkAllShops
      if (this.checkAllShops) {
        this.shopSelectors = this.shopLists.map(ele => { return ele.id })
      } else {
        this.shopSelectors = []
      }
    },
    handleCheckAllGradeChange: function() {
      this.checkAllGrade = !this.checkAllGrade
      if (this.checkAllGrade) {
        this.gradeSelectors = this.gradeLists.map(ele => { return ele.id })
      } else {
        this.gradeSelectors = []
      }
    }
  }
}
</script>
<style lang="scss" scope>

.combo-group {
  .tuolele-main-search {
    .el-button {
      margin-left:0px!important
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
  }
}
</style>
